import {useState} from 'react';
import AppDialog from '../../../../../../../components/common/AppDialog';
import AppTextInput from '../../../../../../../components/common/AppTextInput';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
};

function AddFolderDialog({open, onClose, onSave}: Props) {
  const [folderName, setFolderName] = useState('');

  const canSave = folderName.trim().length > 0;

  const handleOnClose = () => {
    setFolderName('');
    onClose();
  };

  const handleSave = () => {
    onSave(folderName.trim());
    handleOnClose();
  };

  return (
    <AppDialog
      showModel={open}
      onClose={handleOnClose}
      showCloseIcon={false}
      containerClasses="!rounded-[12px] !pt-3 !border-none"
      headerClasses="!px-0"
      width={309}
      titleField={<p className="m-0 text-base font-medium">הוספת תיקיה</p>}
      showHeaderLine={false}>
      <div className="flex flex-col gap-4">
        <AppTextInput
          className="border-0"
          value={folderName}
          onChange={event => setFolderName(event.target.value)}
        />

        <div className="flex justify-end">
          <div className="flex items-center gap-5">
            <button
              type="button"
              className="text-base font-medium text-darkGray"
              onClick={handleOnClose}>
              ביטול
            </button>
            <button
              type="button"
              disabled={!canSave}
              className={`text-base font-medium ${
                canSave
                  ? 'text-darkGreen'
                  : 'text-darkGray cursor-not-allowed opacity-50'
              }`}
              onClick={handleSave}>
              שמירה
            </button>
          </div>
        </div>
      </div>
    </AppDialog>
  );
}

export default AddFolderDialog;
